const masks = {
    cep: '99.999-999',
    cpf: '999.999.999-99',
    cnpj: '99.999.999/9999-99',
    creditCard: '9999 9999 9999 9999',
    creditCardCVV: '9999'
};

export default masks;
